import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { PeculioService } from 'src/app/pages/privado/services/previdencia/peculio.service';
import { AuthService } from 'src/app/shared/guards/auth.service';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent {
    constructor(private router: Router, private authService: AuthService, private usuarioService: UsuarioService,
        private tokenService: TokenService, private route: ActivatedRoute, private peculioService: PeculioService) {
        this.route.queryParams.subscribe((params: any) => {
            if (params.token) {
                this.tokenService.setLoggedToken(params.token);
            }
            const callback = () => {
                this.getPerfil();
            };
            this.authService.updateUser(callback);
        });
    }
    atualizarUsuarioLogado(socialSecurityProfile: any | null, healthProfile: any | null) {
        let actualUser = this.tokenService.getActiveUser();
        this.tokenService.removeLoggedUser();
        actualUser.socialSecurityProfile = socialSecurityProfile;
        actualUser.healthProfile = healthProfile;
        this.tokenService.setLoggedUser(actualUser);
        const peculioObs = this.peculioService.getPeculio();
        const profilesObs = this.usuarioService.getProfiles();
        forkJoin([peculioObs, profilesObs]).subscribe({
            next: ([peculioRes, profilesRes]) => {
                let peculio = peculioRes as any;
                let profile = profilesRes as any;
                actualUser.hasPdvPermission = profile.hasPdvPermission;
                actualUser.hasBpdPermission = profile.hasBpdPermission;
                actualUser.hasBsaPermission = profile.hasBsaPermission;
                if (peculio?.length > 0) {
                    actualUser.peculio = 1;
                }
                this.tokenService.removeLoggedUser();
                this.tokenService.setLoggedUser(actualUser);
            },
        });
    }

    carregando: boolean = true;
    getPerfil() {
        this.usuarioService.getProfiles().subscribe((perfil: any) => {
            let redirect = "home";
            console.log('carregando')
                this.carregando = false;
            
            this.route.queryParams.subscribe((params: any) => {
                if (params && params.redirect && params.redirect != "" && params.redirect != "undefined") {
                    redirect = params.redirect;
                }
                //sem perfil
                if (perfil.socialSecurity?.length === 0 && perfil.health?.length === 0) {
                    this.router.navigate(["/access-denied"]);
                } //apenas 1 perfil de saude
                else if (perfil.socialSecurity?.length == 0 && perfil.health?.length >= 1 || perfil.socialSecurity == null) {
                    perfil.health[0].multiplo = false;
                    this.atualizarUsuarioLogado(null, perfil.health[0]);
                    this.router.navigate([redirect]);
                } //apenas 1 perfil de previdencia
                else if (perfil.socialSecurity?.length >= 1 && perfil.health?.length == 0) {
                    perfil.socialSecurity[0].multiplo = false;
                    this.atualizarUsuarioLogado(perfil.socialSecurity[0], null);
                    this.router.navigate([redirect]);
                } //apenas 1 perfil de ambos os produtos
                else if (perfil.socialSecurity?.length >= 1 && perfil.health?.length >= 1) {
                    if (perfil.socialSecurity?.length == 1)
                        perfil.socialSecurity[0].multiplo = false;
                    if (perfil.health?.length == 1)
                        perfil.health[0].multiplo = false;
                    this.atualizarUsuarioLogado(perfil.socialSecurity[0], perfil.health[0]);
                    this.router.navigate([redirect]);
                } //mais de 1 perfil
                else {
                    if (perfil.socialSecurity?.length > 1) {
                        perfil.socialSecurity.forEach((p: any) => p.multiplo = true);
                    }
                    if (perfil.health?.length > 1) {
                        perfil.health.forEach((p: any) => p.multiplo = true);
                    }
                }
            });
        });
        
    }
}
